export default {
  page(state, value) {
    state.page = value;
  },
  perPage(state, value) {
    state.perPage = value;
  },
  shiftSchedules(state, value) {
    state.shiftSchedules = value;
  },
  total(state, value) {
    state.total = value;
  },
  dates(state, value) {
    state.dates = value;
  },
  schedularFormData(state, value) {
    state.schedularFormData = value;
  },
  loading(state, value) {
    state.loading = value;
  },
  shiftTypes(state, value) {
    state.shiftTypes = value;
  },
};
